import { TherapeuticGroupStatus } from '@dreryk/egabinet-group-session-frontend-api';

import { createInterpolatedTranslationKey, TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanel,
   FilterPanelControllerCodecConfigArray,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { GroupSessionsFilterPanelSearchParam } from '../../GroupSessionsFilterPanel.types';

export const STATUSES: TherapeuticGroupStatus[] = ['DRAFT', 'READY', 'ACTIVE', 'COMPLETED', 'CANCELLED'];

const STATUS_TO_SEARCH_PARAM: Record<TherapeuticGroupStatus, number> = {
   DRAFT: 0,
   READY: 1,
   ACTIVE: 2,
   COMPLETED: 3,
   CANCELLED: 4,
};

export const createStatusTriggerLabelExtractor = (
   translate: TranslateFunction
): ((chosenStatuses: TherapeuticGroupStatus[]) => string) => {
   return (chosenStatuses) => {
      if (chosenStatuses.length === 1) {
         return translate(translationKeys.groupSessionsStatusMap[chosenStatuses.at(0)!]);
      }
      return translate(
         createInterpolatedTranslationKey(translationKeys.chosenOptions, {
            count: chosenStatuses.length,
            totalCount: STATUSES.length,
         })
      );
   };
};

export const statusesCodec: FilterPanelControllerCodecConfigArray<TherapeuticGroupStatus> = {
   type: 'array',
   items: STATUSES,
   keyGenerator: (status) => STATUS_TO_SEARCH_PARAM[status],
};

export const statusesDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   TherapeuticGroupStatus[],
   GroupSessionsFilterPanelSearchParam.STATUS
> = (currentStatuses) => {
   return currentStatuses.map((status) => ({
      targetValue: currentStatuses.filter((currentStatus) => currentStatus !== status),
      label: translationKeys.groupSessionsStatusMap[status],
      testId: `status-${status}`,
   }));
};

export const statusDeserializer = (currentParamValue: string | null): TherapeuticGroupStatus[] => {
   return FilterPanel.paramToArray(
      currentParamValue,
      'number',
      (item) => STATUSES.find((status) => STATUS_TO_SEARCH_PARAM[status] === item)!
   );
};
